import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const apiUrl = process.env.REACT_APP_API_URL || "";
const apiPrefix = process.env.REACT_APP_API_PREFIX || "/api/v1";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${apiUrl}${apiPrefix}`,
    credentials: "include",
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");

      const guestKey = localStorage.getItem("guest_session_key");
      if (guestKey) headers.set("X-Guest-Key", guestKey);

      return headers;
    },
  }),
  tagTypes: [
    "StoreMe",
    "StorePage",
    "StoreProduct",
    "StoreProductList",
    "header_main",
    "StoreMenu",
    "StoreCart",
    "StoreProfile",
    "StoreAddress",
    "StoreShippingCountries",
    "StoreShippingDeliveryTypes",
  ] as const,
  endpoints: () => ({}),
});